export const prefix = "bat"
export const iconName = "pencil"
export const width = 16
export const height = 16
export const ligatures = []
export const unicode = ""
export const svgPathData =
    "M0 12.6671V16H3.33288L13.1627 6.17022L9.82978 2.83734L0 12.6671ZM15.7401 3.5928C15.8225 3.51057 15.8878 3.41291 15.9324 3.30539C15.977 3.19787 16 3.08261 16 2.96621C16 2.84981 15.977 2.73456 15.9324 2.62704C15.8878 2.51952 15.8225 2.42186 15.7401 2.33963L13.6604 0.259915C13.5781 0.177523 13.4805 0.112156 13.373 0.0675565C13.2654 0.0229568 13.1502 0 13.0338 0C12.9174 0 12.8021 0.0229568 12.6946 0.0675565C12.5871 0.112156 12.4894 0.177523 12.4072 0.259915L10.7808 1.88636L14.1136 5.21924L15.7401 3.5928Z"

export const definition = {
    prefix,
    iconName,
    icon: [width, height, ligatures, unicode, svgPathData],
}

export const batPencil = definition
